"use client";

import { useState } from "react";
import { getECGImageUrl } from "@/app/lib/api";

interface Props {
  ecgId: number;
  format?: string;
}

export function ECGImage({ ecgId, format = "png" }: Props) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const imageUrl = getECGImageUrl(ecgId, format);

  if (error) {
    return (
      <div className="flex items-center justify-center h-64 bg-red-50 rounded border border-red-200 text-red-600 text-sm">
        Failed to generate ECG image
      </div>
    );
  }

  return (
    <div className="relative w-full h-full flex items-center justify-center">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded z-10">
          <div className="text-center">
            <div className="animate-pulse text-sm text-gray-500">Generating ECG image...</div>
          </div>
        </div>
      )}
      <a href={imageUrl} target="_blank" rel="noopener noreferrer" className="w-full h-full flex items-center justify-center">
        <img
          src={imageUrl}
          alt={`ECG recording ${ecgId}`}
          className="w-full h-full object-contain rounded border cursor-pointer"
          onLoad={() => setLoading(false)}
          onError={() => { setLoading(false); setError(true); }}
        />
      </a>
    </div>
  );
}